// extracted by mini-css-extract-plugin
module.exports = {"combiAd":"combi-ad_combiAd__TNerf","title":"combi-ad_title__8qPFN"};